import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IModuleCertificateQuery } from 'app/library/module-certificate/interfaces/module-certificate.query.interface';
import { IEnvironment } from 'app/projects/core/src/lib/interfaces/environment.interface';
import { MAXBRAIN_ENVIRONMENT } from 'app/projects/core/src/lib/services/environment.token';
import { Observable } from 'rxjs';

@Injectable()
export class ModuleCertificatesApiService {
    constructor(private http: HttpClient, @Inject(MAXBRAIN_ENVIRONMENT) private environment: IEnvironment) {}

    getAll(moduleId: string): Observable<IModuleCertificateQuery[]> {
        return this.http.get<IModuleCertificateQuery[]>(`${this.environment.apiUrl}/certificate-of-attendance/modules/${moduleId}/templates`);
    }
}
